import React from 'react';
import Review from "./Review";
import ErrorBoundary from "@Errors/components/ErrorBoundary"
import ReviewType from "@Pages/reviews/types/Review.type";
import ReviewStationType from "@Pages/reviews/types/ReviewStation.type";

interface ReviewListProps {
    reviews: ReviewType[],
    stationHandler: (station: ReviewStationType) => void,
    activeStationHandler: (stations: string[]) => void,
    filteredStations: string[],
    companyHandler: (company: string) => void
}

function ReviewList({reviews, stationHandler, activeStationHandler, filteredStations, companyHandler}: ReviewListProps) {
    return (
        <>
            {reviews?.map((review, index) => {
                const {
                    ticketId,
                } = review
                const key = `${ticketId}-${index}`

                return (
                    <ErrorBoundary shouldReload={false} key={key}>
                        <Review
                            stationHandler={stationHandler}
                            companyHandler={companyHandler}
                            activeStationHandler={activeStationHandler}
                            filteredStations={filteredStations}
                            review={review}
                            key={key}
                        />
                    </ErrorBoundary>
                )
            })}
        </>
    )
}

export default ReviewList;